<template>
  <div class="hvh-relative w-100">
    <HvhChart :visualization="visualization" :options="options" :height="height" @item-clicked="$emit('item-clicked', $event)" />
    <loader v-if="isFiltering" />
  </div>
</template>
<script>
import { Debouncer, hashCode } from '../../../libraries/common';
import HvhChart from '../HvhChart.vue';
export default {
  components: { HvhChart },
  props: ['visualization', 'options', 'height', 'filterObject', 'isFiltering'],
  data() {
    return {
      debounceFnc: new Debouncer(2000),
    };
  },
  computed: {
    filterHash() {
      return hashCode(this.filterObject || {});
    }
  },
  watch: {
    filterHash() {
      this.debounceFnc.clear().push(() => this.$emit('refresh-data', this.filterObject));
    },
  },
  mounted() {
    this.$emit('chart-created', this.filterObject);
  },
};
</script>
